export class Uint8ArraySink extends WritableStream {
    constructor(options) {
        super({
            ...options,
            write: (chunk) => {
                this.data = new Uint8Array([...this.data, ...chunk]);
            },
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Uint8Array()
        });
    }
}
